import Link from "next/link";
import { LogIn, Menu } from "lucide-react";
import { BrandLogo, BrandWordmark } from "@/components/brand-logo";

const NAV_ITEMS = [
  { label: "Tử vi", href: "/tu-vi" },
  { label: "Phong thủy", href: "/phong-thuy" },
  { label: "Hợp tuổi", href: "/hop-tuoi" },
  { label: "Lịch", href: "/lich" },
  { label: "AI", href: "/ai" },
  { label: "Bài viết", href: "/blog" },
  { label: "Bảng giá", href: "/pricing" },
];

export function SiteHeader() {
  return (
    <header className="bg-bg-base/80 border-stroke-subtle sticky top-0 z-30 border-b backdrop-blur-md">
      <div className="max-w-container mx-auto flex h-16 items-center justify-between px-4 lg:h-[72px] lg:px-6">
        <Link href="/" className="group flex items-center gap-2.5">
          <BrandLogo />
          <BrandWordmark />
        </Link>

        <nav aria-label="Điều hướng chính" className="hidden items-center gap-7 text-sm lg:flex">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              className="text-ink-secondary hover:text-brand-gold transition-colors"
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            href="/login"
            className="text-ink-secondary hover:text-ink-primary hover:bg-bg-elevated hidden items-center gap-2 rounded-md px-4 py-2 text-sm sm:flex"
          >
            <LogIn className="h-4 w-4" aria-hidden="true" />
            <span>Đăng nhập</span>
          </Link>
          <Link
            href="/register"
            className="bg-brand-gold text-bg-base hover:bg-brand-gold/90 rounded-md px-4 py-2 text-sm font-medium active:translate-y-px"
          >
            Đăng ký
          </Link>
          <button
            type="button"
            aria-label="Mở menu"
            className="text-ink-secondary hover:text-ink-primary p-2 lg:hidden"
          >
            <Menu className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
      </div>
    </header>
  );
}
